import { createSelector } from '@reduxjs/toolkit';

// The list surface never reads createJob/updateJob, so it must not subscribe to
// them — a mutation's loading→success cycle re-rendered every card and row.
const LIST_KEYS = [
  'searchTerm',
  'filters',
  'page',
  'sort',
  'currentView',
  'getAllJobs',
];

// The filter bar reads no server data either, so keep getAllJobs out of it too.
const FILTER_BAR_KEYS = ['searchTerm', 'filters', 'sort', 'currentView'];

// Job create/edit watches only its own request, so it must not re-render every
// time the list refetches or pages.
const MUTATION_KEYS = ['createJob', 'updateJob'];

// Memoised: built inline it returned a fresh object on every call, so every
// consumer re-rendered on any dispatch anywhere in the app.
const selectSlices = (keys) =>
  createSelector(
    keys.map((key) => (state) => state?.atsJobs?.[key]),
    (...values) =>
      keys.reduce((acc, key, index) => {
        acc[key] = values[index];
        return acc;
      }, {})
  );

export const getAtsJobsList = selectSlices(LIST_KEYS);
export const getAtsJobsFilterBar = selectSlices(FILTER_BAR_KEYS);
export const getAtsJobsMutations = selectSlices(MUTATION_KEYS);
